export const convertNumericStringProperties = <T extends Record<string, any>>(
    obj: T
): Record<string, any> => {
    const newEntries = Object.entries(obj).map(([key, value]) => {
        let newValue: unknown = value;

        if (typeof value === "string") {
            const trimmedValue = value.trim();

            if (trimmedValue !== "" && !isNaN(Number(trimmedValue))) {
                newValue = Number(trimmedValue);
            }
        }

        return [key, newValue];
    });

    return Object.fromEntries(newEntries);
};
